import { useEffect, useMemo, useState } from 'react';

export const useForm = ( initialForm = {} ) => {
  
    const [ formState, setFormState ] = useState( initialForm );
    
    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const formatNumber = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    };

    const onInputChangeThousands = ({ target }) => {
        const { name, value } = target;
        const newValue = formatNumber(value)
        setFormState({
            ...formState,
            [ name ]: value,
            [ `${name}_formateado` ]: newValue
        });
    }

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onResetForm = () => {
        setFormState( initialForm );
    }

    return {
        ...formState,
        formState,
        setFormState,
        onInputChange,
        onInputChangeThousands,
        onSelectSearchChange,
        onResetForm
    }
}